import { render } from "./MainTemplate.vue?vue&type=template&id=57781510&scoped=true"
const script = {}

import "./MainTemplate.vue?vue&type=style&index=0&id=57781510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57781510"]])

export default __exports__